import { RootState } from 'global/state';
import { Banner } from 'labxchange-client';

export const getVisibleBanners = (state: RootState) => {
    const banners: Banner[] = state.bannerState.banners.filter((banner) => {
        let bannerId = banner.id;
        if (bannerId && !banner.action) {
            if (banner.regexUrl !== undefined) {
                try {
                  const pattern = new RegExp(banner.regexUrl);
                  const path = window.location.href;

                  /// I change the banner id to display a new banner in each page that comply with the regex pattern
                  bannerId = banner.id + ':' + btoa(path);
                  return !state.bannerState.dismissed.has(bannerId) && pattern.test(path);
                }
                catch (e) {
                  /// If the expression is invalid
                  return false;
                }
            }
            return !state.bannerState.dismissed.has(bannerId);
        }
        return false;
    });
    if (!banners) {
        return undefined;
    }
    return banners;
};

export const getCookieAcceptanceBanner = (state: RootState) => {
    const banners: Banner[] = state.bannerState.banners.filter((banner) => (
        banner.action && banner.action === 'cookie_acceptance'
    ));
    return banners.length > 0 ? banners[0] : undefined;
};
